import { render, staticRenderFns } from "./CreditNoteListAdmin.vue?vue&type=template&id=0534c35c&scoped=true"
import script from "./CreditNoteListAdmin.vue?vue&type=script&lang=js"
export * from "./CreditNoteListAdmin.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteListAdmin.vue?vue&type=style&index=0&id=0534c35c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534c35c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0534c35c')) {
      api.createRecord('0534c35c', component.options)
    } else {
      api.reload('0534c35c', component.options)
    }
    module.hot.accept("./CreditNoteListAdmin.vue?vue&type=template&id=0534c35c&scoped=true", function () {
      api.rerender('0534c35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/creditnote/CreditNoteListAdmin.vue"
export default component.exports